import * as React from 'react';

const PlusIcon = ({fillColor = '#2D2756'}) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    // fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 6.5H12M6.5 1L6.5 12"
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlusIcon;
